var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3534 24.2491C16.2149 24.8034 16.0763 25.2191 16.0763 25.7733C15.9377 26.8819 15.7992 27.8519 15.7992 28.9604C15.7992 29.2375 15.7992 29.5147 15.7992 29.7918C14.6906 30.3461 13.8592 30.4847 13.1664 30.069C12.7507 29.7918 12.4735 29.3761 12.1964 28.5447C11.9192 27.5747 11.9192 26.0505 12.0578 24.3876C12.335 20.9234 13.5821 17.3207 13.5821 17.0435C14.6906 19.6763 15.6606 22.032 16.3534 24.2491Z",
    fill: "url(#paint0_linear_1607_124405)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.374 3.18742C25.6327 5.95879 22.8613 9.00729 20.5056 13.5801C20.0899 12.7486 19.6742 12.0558 19.2585 11.2244C18.7042 10.393 18.15 9.423 17.5957 8.59159C18.4271 7.20591 18.9814 6.51306 19.8128 5.40452C19.8128 5.26595 19.9514 5.26595 19.9514 5.12738C21.0599 3.88026 22.1685 2.77172 23.4156 1.80174C24.5241 0.831758 25.6327 0.277484 26.4641 0.138916C26.4641 0.138916 26.4641 0.138916 26.6027 0.138916H26.7412C26.7412 0.138916 26.7412 0.138916 26.8798 0.138916H27.0184C27.0184 0.138916 27.0184 0.138916 27.1569 0.138916C27.4341 0.138916 27.8498 0.138916 28.1269 0.277484C28.8197 0.69319 29.2355 1.66317 29.374 3.18742Z",
    fill: "url(#paint1_linear_1607_124405)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7323 21.2009C28.6838 27.0208 25.081 31.5935 22.1711 33.3949C22.1711 33.3949 22.0325 33.5335 21.894 33.5335H21.7554C21.7554 33.5335 21.7554 33.5335 21.6168 33.5335C21.6168 33.5335 21.6168 33.5335 21.4783 33.5335H21.3397H21.2011C21.0626 33.5335 21.0626 33.5335 20.924 33.6721C20.924 33.6721 20.7854 33.6721 20.6469 33.8106H20.5083H20.3697H20.2312H20.0926C19.954 33.8106 19.954 33.8106 19.8154 33.8106C19.6769 33.8106 19.6769 33.8106 19.5383 33.8106C19.3997 33.8106 19.3997 33.8106 19.2612 33.8106C19.1226 33.8106 19.1226 33.8106 18.984 33.8106C18.8455 33.8106 18.7069 33.8106 18.5683 33.8106H18.4298C18.4298 33.8106 18.4298 33.8106 18.2912 33.8106C18.1526 33.8106 18.1526 33.8106 18.0141 33.8106H17.8755H17.7369H17.5984H17.4598H17.3212H17.1826H17.0441H16.9055C16.7669 33.8106 16.7669 33.8106 16.6284 33.6721C16.4898 33.6721 16.3512 33.5335 16.3512 33.5335C16.3512 33.5335 16.3512 33.5335 16.2127 33.5335C14.5498 32.7021 13.7184 31.5935 13.3027 30.7621C13.9956 30.9007 14.5498 30.9007 15.1041 30.9007C15.2427 30.9007 15.3813 30.7621 15.6584 30.7621C15.9355 30.6236 16.2127 30.6236 16.4898 30.3464H16.6284C16.9055 30.2079 17.3212 29.9307 17.5984 29.7922C17.7369 29.6536 17.8755 29.515 18.1526 29.3764C18.4298 29.2379 18.7069 28.9607 18.984 28.6836C19.1226 28.545 19.2612 28.4065 19.3997 28.2679C20.5083 27.1594 21.6168 25.7737 22.864 24.1108C23.2797 23.418 23.8339 22.7252 24.2496 22.0323C25.081 20.6466 25.9125 19.261 26.6053 17.7367C29.0995 12.7482 30.4852 7.89834 30.7624 4.43413C30.7624 3.87986 30.7624 3.46415 30.7624 3.04844C30.7624 2.90988 30.7624 2.90988 30.7624 2.77131C30.7624 2.77131 30.7624 2.49417 30.6238 2.07847V1.9399C30.6238 1.80133 30.4852 1.66276 30.4852 1.38562C29.7924 1.10849 29.5152 0.554213 29.0995 -6.10352e-05C30.0695 0.138507 31.4552 0.415644 32.8409 1.24705C32.9795 1.24705 32.9795 1.38562 33.118 1.38562C35.7508 3.32558 35.8894 5.40411 35.8894 5.40411C36.4437 8.72975 34.9194 14.8268 31.7323 21.2009Z",
    fill: "url(#paint2_linear_1607_124405)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0736 30.6239C16.0736 30.6239 15.7965 30.7625 15.2422 31.0396C15.5193 30.901 15.7965 30.7625 16.0736 30.6239Z",
    fill: "url(#paint3_linear_1607_124405)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.003 21.7549C22.5873 22.4478 22.1716 23.1406 21.6173 23.8335C20.5087 25.4963 19.4002 26.7434 18.2917 27.8519C18.1531 27.9905 18.0145 28.1291 17.8759 28.2676C17.8759 27.9905 17.8759 27.8519 17.7374 27.5748C17.5988 27.0205 17.5988 26.3277 17.4602 25.6348C17.3217 24.8034 17.0445 23.972 16.7674 23.002C15.6589 19.5378 14.1346 16.0736 12.1946 12.8865C11.9175 12.3323 11.5018 11.778 11.0861 11.2237C10.3933 9.83804 9.56184 8.59093 8.4533 7.48238C7.76045 6.5124 6.79047 5.54242 5.82049 4.71101C5.26622 4.29531 4.71195 3.8796 4.15767 3.4639C3.32626 3.04819 1.80201 2.35535 0.832031 3.74103V3.60246C1.52487 2.63249 2.35628 1.93964 3.32626 1.38537C4.01911 0.969664 4.85052 0.553959 5.68193 0.276822C8.03759 -0.831725 12.7489 3.18676 17.0445 9.42234C17.5988 10.1152 18.1531 11.0852 18.7074 11.9166C19.1231 12.748 19.6773 13.4408 19.9545 14.2722C20.2316 14.6879 20.3702 15.2422 20.6473 15.6579C21.7559 17.875 22.4487 19.9535 23.003 21.7549Z",
    fill: "url(#paint4_linear_1607_124405)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7483 32.2859C8.59124 29.0989 5.40417 25.219 3.04851 20.5076C1.38568 17.182 0.277137 13.4406 0 9.69929C0 8.59074 -1.34214e-07 7.62076 0.138568 6.51221C0.138568 6.51221 0.138569 6.23508 0.277137 5.81937C0.277137 5.6808 0.277137 5.6808 0.415705 5.54223C1.38568 3.18657 3.18707 4.01798 4.15705 4.57225C3.74135 7.8979 4.98846 13.5792 7.8984 19.3991C8.72981 20.9233 9.28409 22.0319 10.1155 23.1404C10.3926 23.5561 10.8083 23.9718 11.0855 24.5261L11.224 24.6647C10.8083 27.7132 11.3626 30.346 12.7483 32.2859Z",
    fill: "url(#paint5_linear_1607_124405)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1607_124405",
    x1: 24.6114,
    y1: -1.27038,
    x2: 10.7731,
    y2: 32.9085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1944,
    stopColor: "#D60B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4951,
    stopColor: "#312783"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7363,
    stopColor: "#D60B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1607_124405",
    x1: 26.1336,
    y1: -0.651478,
    x2: 12.2953,
    y2: 33.5275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1944,
    stopColor: "#D60B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4951,
    stopColor: "#312783"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7363,
    stopColor: "#D60B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1607_124405",
    x1: 17.0035,
    y1: 33.6078,
    x2: 35.4267,
    y2: 2.09648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#D60B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#312783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1607_124405",
    x1: 16.2156,
    y1: 30.329,
    x2: 15.4165,
    y2: 31.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000343525,
    stopColor: "#D60B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1607_124405",
    x1: 21.1672,
    y1: 23.697,
    x2: -0.0904174,
    y2: -5.06333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#D60B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#312783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1607_124405",
    x1: -3.53959,
    y1: 1.65955,
    x2: 18.635,
    y2: 35.7551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#D60B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#312783"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.5de1f323056aea98337844a17a19f41a.svg";
export { ForwardRef as ReactComponent };